import React, { Fragment } from "react";

import { withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getBanners, getHomeAds } from "../../actions/categories";

import ShopByDepartment from "../../components/shopByDepartment/shopByDepartment.component";
import Slider from "../../components/slider/slider.component";
import OfferOne from "../../components/offerOne/offerOne.component";
import BannerOne from "../../components/bannerOne/bannerOne.component";
import Sofas from "../../components/Sofas/sofas.component";
// import OttomansAndPoufs from "../../components/OttomansAndPoufs/ottomansAndPoufs.component";
import BannerTwo from "../../components/bannerTwo/bannerTwo.component";
// import Blog from "../../components/blog/blog.component";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = { banners: null, getHomeAds: null };
  }

  async componentDidMount() {
    const res = await this.props.getBanners();
    const getHomeAds = await this.props.getHomeAds();

    this.setState({ banners: res, getHomeAds: getHomeAds });
  }

  render() {
    const { banners, getHomeAds } = this.state;
    return (
      <Fragment>
        <Slider />
        <ShopByDepartment />

        {banners && <BannerOne banners={banners} getHomeAds={getHomeAds} />}

        <Sofas />
        {getHomeAds && <OfferOne getHomeAds={getHomeAds} />}
        {banners && <BannerOne banners={banners} getHomeAds={getHomeAds} />}
      </Fragment>
    );
  }
}

getBanners.propTypes = {
  getBanners: PropTypes.func.isRequired,
};
getHomeAds.propTypes = {
  getHomeAds: PropTypes.func.isRequired,
};

export default withRouter(connect(null, { getBanners, getHomeAds })(Index));
